<template>
  <div class="home page" ref="page" :style="blockHeight">
    <UiDataBox :loading="loading" :error="error">
      <div class="index-image" v-if="item.id">
        <div class="info top">
          <div class="title" :style="titleFontSize">
            <router-link class="title link" :to="{ name: 'album-view', params: {albumId: item.id} }">{{ item.title }}</router-link>
          </div>
          <div class="tags-wrapper" :style="tagsFontSize">
            <TagsView :tagsList="item.tags" labelName="name"></TagsView>
          </div>
        </div>

        <div class="info bottom BOLD" :style="dateFontSize">
          {{ $moment(item.event_date).format($FORMAT_DATETIME.DATE) }}
        </div>
        <ImgLoader :src="item._cover_index"></ImgLoader>
      </div>
    </UiDataBox>
  </div>
</template>

<script>
  import * as albumsService from '../services/albums.service'

  import setModelMixin from '../mixins/setModelMixin'
  import TagsView from '../components/TagsView.vue'
  import ImgLoader from '../components/ImgLoader.vue'

  export default {
    name: 'Index',
    mixins: [setModelMixin],
    components: {
      TagsView,
      ImgLoader
    },
    data () {
      return {
        loading: false,
        error: false,
        titleFontSize: {},
        tagsFontSize: {},
        dateFontSize: {},
        blockHeight: {},
        item: {
          id: null,
          user_id: '',
          title: '',
          description: '',
          private: '',
          event_location: '',
          event_date: '',
          created_at: '',
          _cover_thumbnail: '',
          _cover_index: '',
          tags: []
        }
      }
    },

    methods: {
      setStyle () {
        this.titleFontSize = { 'font-size': `${this.getPageWidth() * 70 / 1000}px` }
        this.tagsFontSize = { 'font-size': `${this.getPageWidth() * 15 / 1000}px` }
        this.dateFontSize = { 'font-size': `${this.getPageWidth() * 25 / 1000}px` }
        this.blockHeight = { 'height': `${parseInt(this.getPageWidth() / 2.33)}px` }
      },
      getPageWidth () {
        return this.$refs.page ? this.$refs.page.offsetWidth : 1280
      },
      fetchLastAlbum () {
        this.loading = true
        albumsService.getLast()
          .then(response => {
            this.item = this.setModelMixin(this.item, response.data)
          })
          .catch(error => {
            this.error = error.message
            console.log(error)
          }).finally(() => { this.loading = false })
      }
    },

    mounted () {
      window.addEventListener('resize', () => this.setStyle())
      this.setStyle()
      this.fetchLastAlbum()
    }
  }
</script>

<style lang="scss" scoped>
  .home {
    font-family: $font-title;
    text-transform: uppercase;

    .index-image {
      width: 100%;
      height: 100%;
      position: relative;
      z-index: 2;
      .info {
        opacity: .5;
        z-index: 1;
      }
      .info.top {
        position: absolute;
        top: 14%;
        padding-left: 3%;
        min-width: 50%;
        .title {
          //
        }
        .tags-wrapper {
          //
        }
      }
      .info.bottom {
        position: absolute;
        bottom: 3%;
        right: 3%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue